<template>
  <div>
    <slot/>
  </div>
</template>

<script>
import { applyRatio, getOffsetTop } from '@/utils';
import responsive from '@/utils/responsive';

export default {
  name: 'PrBlock',
  data() {
    return {
      innerList: [],
    };
  },
  watch: {
    sv: 'render',
  },
  methods: {
    inner(r) {
      const x = this.onFix ? 1 : r;
      applyRatio(this.innerList, x);
    },
    render() {
      if (!this.$el) return;
      const sv = this.sv;
      let d = getOffsetTop(this.$el) - sv;
      const h = window.innerHeight;
      if (d < -window.innerHeight * 2 || d > window.innerHeight * 2) return;
      if (d < 0) d = 0;
      this.inner(d / h);
    }
  },
  mounted() {
    this.innerList = this.$el.querySelectorAll('[data-p]');
    responsive.addListener(this.render);
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
  }
};
</script>

<style lang="less">
@import "~@/less/proj";

</style>
